import { LookupFields, UserFields } from "src/modules/modules.type";
import { FIELDS_TYPES } from "./type.config";
import { LookUpRecord, UserRecord } from "src/types/main";

export const myTasksLocationsListName = "MyTasksLocations"; // mt-locations
export const myTasksDepartmentsListName = "MyTasksDepartments"; // mt-departments
export const myTasksRegionsListName = "MyTasksRegions"; // mt-areas

export const myTasksDependListName = "MyTasksDepend";
export const myTasks5WayDependListName = "MyTasks5WayDepend";
export const myTasksDeviationReportDependListName = "MyTasksDeviationReportDepend";
export const myTasksKpiByTriggerListName = "MyTasksKpiByTrigger";
export const myTasksDeviationReportKpiByTriggerListName = "MyTasksDeviationReportKpiByTrigger";
export const myTasksTriggersListName = "MyTasksTriggers";
export const myTasksDeviationReportTriggersListName = "MyTasksDeviationReportTriggers";
export const myTasksKPIListName = "MyTasksKPI";
export const myTasks5WayStatusesListName = "MyTasks5WayStatuses";
export const myTasksSDCAListName = "MyTasksSDCA";
export const myTasksTreeCategoriesListName = "MyTasksTreeCategories";
export const MTFavoriteFiltersListName = "MTFavoriteFilters";
export const MTTriggersPageListName = "MTTriggersDependRe";

export const MyTaskListsNameFields = {
  [myTasksLocationsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTasksTreeCategoriesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTasksDepartmentsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    User_Department: FIELDS_TYPES.STRING,
  },
  [myTasksRegionsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTasksDependListName]: {
    ID: FIELDS_TYPES.ID,
    Location: FIELDS_TYPES.LOOKUP,
    Departament: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
  },
  [myTasks5WayDependListName]: {
    ID: FIELDS_TYPES.ID,
    Location: FIELDS_TYPES.LOOKUP,
    Departament: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Trigger: FIELDS_TYPES.LOOKUP,
    Hide: FIELDS_TYPES.BOOLEAN
  },
  [MTTriggersPageListName]: {
    ID: FIELDS_TYPES.ID,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Departament: FIELDS_TYPES.LOOKUP,
    Area: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Trigger: FIELDS_TYPES.LOOKUP,
    Hide: FIELDS_TYPES.BOOLEAN,
    Kpi: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.STRING
  },
  [myTasksDeviationReportDependListName]: {
    ID: FIELDS_TYPES.ID,
    Location: FIELDS_TYPES.LOOKUP,
    Departament: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Trigger: FIELDS_TYPES.LOOKUP,
    Hide: FIELDS_TYPES.BOOLEAN
  },
  [myTasksKpiByTriggerListName]: {
    ID: FIELDS_TYPES.ID,
    Trigger: FIELDS_TYPES.LOOKUP,
    Kpi: FIELDS_TYPES.LOOKUP,
  },
  [myTasksDeviationReportKpiByTriggerListName]: {
    ID: FIELDS_TYPES.ID,
    Trigger: FIELDS_TYPES.LOOKUP,
    Kpi: FIELDS_TYPES.LOOKUP,
  },
  [myTasksTriggersListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTasksDeviationReportTriggersListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTasksKPIListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTasks5WayStatusesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Color: FIELDS_TYPES.STRING,
    Text5Way: FIELDS_TYPES.STRING,
    TextDeviationReport: FIELDS_TYPES.STRING,
  },
  [myTasksSDCAListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    SDCAGroup: FIELDS_TYPES.STRING,
  },
  [MTFavoriteFiltersListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    MTFilters: FIELDS_TYPES.STRING,
    DisplayFilters: FIELDS_TYPES.STRING,
    MTFullFilters: FIELDS_TYPES.STRING,
    Type: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    DefaultFilter: FIELDS_TYPES.BOOLEAN,
  },
};

export type MyTaskListsFieldsRecordType = {
  [myTasksLocationsListName]: {
    ID: number;
    Title: string;
  };
  [myTasksDepartmentsListName]: {
    ID: number;
    Title: string;
    User_Department: string;
  };
  [myTasksTreeCategoriesListName]: {
    ID: number;
    Title: string;
  };
  [myTasksRegionsListName]: {
    ID: number;
    Title: string;
  };
  [myTasksDependListName]: {
    ID: number;
    Location: LookupFields;
    Departament: LookupFields;
    Region: LookupFields;
  };
  [myTasks5WayDependListName]: {
    ID: number;
    Location: LookupFields;
    Departament: LookupFields;
    Region: LookupFields;
    Trigger: LookupFields;
    Hide: boolean;
  };
  [MTTriggersPageListName]: {
    ID: number;
    Location: LookupFields;
    Department: LookupFields;
    Departament: LookupFields;
    Area: LookupFields;
    Region: LookupFields;
    Trigger: LookupFields;
    Hide: boolean;
    Kpi: LookupFields;
    AuthorEmail: string;
  };
  [myTasksDeviationReportDependListName]: {
    ID: number;
    Location: LookupFields;
    Departament: LookupFields;
    Region: LookupFields;
    Trigger: LookupFields;
    Hide: boolean;
  };
  [myTasksKpiByTriggerListName]: {
    ID: number;
    Trigger: LookupFields;
    Kpi: LookupFields;
  };
  [myTasksDeviationReportKpiByTriggerListName]: {
    ID: number;
    Trigger: LookupFields;
    Kpi: LookupFields;
  };
  [myTasksTriggersListName]: {
    ID: number;
    Title: string;
  };
  [myTasksDeviationReportTriggersListName]: {
    ID: number;
    Title: string;
  };
  [myTasksKPIListName]: {
    ID: number;
    Title: string;
  };
  [myTasks5WayStatusesListName]: {
    ID: number;
    Title: string;
    Color: string;
    Text5Way: string;
    TextDeviationReport: string;
  };
  [myTasksSDCAListName]: {
    ID: number;
    Title: string;
    SDCAGroup: string;
  };
  [MTFavoriteFiltersListName]: {
    ID: number;
    Title: string;
    MTFilters: string;
    DisplayFilters: string;
    MTFullFilters: string;
    Type: string;
    Author: UserFields;
    DefaultFilter: boolean;
  };
};

export type MyTaskListsFieldsType = {
  [myTasksLocationsListName]: {
    ID: number;
    Title: string;
  };
  [myTasksDepartmentsListName]: {
    ID: number;
    Title: string;
    User_Department: string;
  };
  [myTasksTreeCategoriesListName]: {
    ID: number;
    Title: string;
  };
  [myTasksRegionsListName]: {
    ID: number;
    Title: string;
  };
  [myTasksDependListName]: {
    ID: number;
    Location: LookUpRecord;
    Departament: LookUpRecord;
    Region: LookUpRecord;
  };
  [myTasks5WayDependListName]: {
    ID: number;
    Location: LookUpRecord;
    Departament: LookUpRecord;
    Region: LookUpRecord;
    Trigger: LookUpRecord;
    Hide: boolean;
  };
  [MTTriggersPageListName]: {
    ID: number;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Departament: LookUpRecord;
    Area: LookUpRecord;
    Region: LookUpRecord;
    Trigger: LookUpRecord;
    Hide: boolean;
    Kpi: LookUpRecord;
    AuthorEmail: string;
  };
  [myTasksDeviationReportDependListName]: {
    ID: number;
    Location: LookUpRecord;
    Departament: LookUpRecord;
    Region: LookUpRecord;
    Trigger: LookUpRecord;
    Hide: boolean;
  };
  [myTasksKpiByTriggerListName]: {
    ID: number;
    Trigger: LookUpRecord;
    Kpi: LookUpRecord;
  };
  [myTasksDeviationReportKpiByTriggerListName]: {
    ID: number;
    Trigger: LookUpRecord;
    Kpi: LookUpRecord;
  };
  [myTasksTriggersListName]: {
    ID: number;
    Title: string;
  };
  [myTasksDeviationReportTriggersListName]: {
    ID: number;
    Title: string;
  };
  [myTasksKPIListName]: {
    ID: number;
    Title: string;
  };
  [myTasks5WayStatusesListName]: {
    ID: number;
    Title: string;
    Color: string;
    Text5Way: string;
    TextDeviationReport: string;
  };
  [myTasksSDCAListName]: {
    ID: number;
    Title: string;
    SDCAGroup: string;
  };
  [MTFavoriteFiltersListName]: {
    ID: number;
    Title: string;
    MTFilters: string;
    DisplayFilters: string;
    MTFullFilters: string;
    Type: string;
    Author: UserRecord;
    DefaultFilter: boolean;
  };
};
